import { ReactElement, ReactNode } from 'react';
import wagmi from '@web3-onboard/wagmi';
import { Web3OnboardProvider, init } from '@web3-onboard/react';
import type { Chain } from '@web3-onboard/common';
import { SupportChains } from '@/config/constants';
import wallets from './wallets';
import logo from '@/assets/logo.svg';
import { WalletContext } from '@/services';
import { clearPendingWalletChainSwitch, markPendingWalletChainSwitch } from '@/services/wallet-chain-switch';

const chains = SupportChains.map((o) => {
    return {
        id: '0x' + o.chainId.toString(16),
        token: o.token,
        label: o.label,
        rpcUrl: o.rpcUrl,
        publicRpcUrl: o.publicRpcUrl,
        secondaryTokens: o.secondaryTokens,
    };
}) as Chain[];
WalletContext.Onboard = init({
    wagmi,
    wallets,
    chains,
    theme: 'dark',
    accountCenter: {
        desktop: { enabled: true, position: 'bottomRight', minimal: true },
        mobile: { enabled: true, position: 'bottomRight', /* 可选 */ minimal: true },
    },
    connect: {
        autoConnectLastWallet: true,
    },
    appMetadata: {
        name: 'Aicade Galaxy',
        icon: logo,
        description: 'Aicade Galaxy Wallet Onboard',
    },
});

const WalletProvider = ({ children }: { children: ReactNode[] | ReactNode }): ReactElement => {
    return <Web3OnboardProvider web3Onboard={WalletContext.Onboard}>{children}</Web3OnboardProvider>;
};

const SetCurChainId = async (chainId: number) => {
    markPendingWalletChainSwitch(chainId);
    try {
        return await WalletContext.Onboard?.setChain({ chainId: `0x${chainId.toString(16)}` });
    } catch (error) {
        clearPendingWalletChainSwitch();
        throw error;
    }
};

export { SetCurChainId };

export default WalletProvider;
